const root = {
    minWidth: "17px",
    height: "15px",
    textAlign: "center",
    display: "inline-block",
    maxWidth: "40px",
    fontFamily: "Saira Condensed",
    fontStyle: "normal",
    color: "#ABABAB"
};
export function getCellVariant(fontSize, fontWeight) {
    return {
        $extendFromVariant: "default",
        root: Object.assign(Object.assign({}, root), { fontSize,
            fontWeight })
    };
}
export const scoreboardWrapperStyles = {
    $extendFromVariant: "default",
    root: {
        maxWidth: ["50%", "50%", "50%", "70%"]
    },
};
//# sourceMappingURL=getCellVariant.js.map